import React, {useRef} from 'react';
import {observer} from "mobx-react";
import {useServices} from '../../../../../../react-hooks/use-services.hook';
import {GameInfo} from '../../../../../../services/games/game-info';
import {FlexGrowItemBox} from '../../../../../../themes/architecture/css-helpers/flex';
import {LiveStreamSlidePlayerContainer} from './boxes/live-stream-slide-player.box';
import {VideoSlidesSoundIconComponent} from "../../../sound-icon/video-slides-sound-icon.component";
import useIsInViewPort from "../../../../../../react-hooks/use-is-in-viewport.hook";

interface LiveStreamSlideHlsPocPlayerProps {
    gameInfo: GameInfo;
}
export const LiveStreamSlideHlsPocPlayerComponent: React.FC<LiveStreamSlideHlsPocPlayerProps> = observer((props) => {
    const services = useServices();
    const liveStreamPlaying = services.liveStreamPlaying;
    let soundContainerRef = useRef(null);

    let isInViewport = useIsInViewPort(soundContainerRef);

    let muted = !isInViewport || liveStreamPlaying.isVideoMuted;

    return (
        <>
            <FlexGrowItemBox />
            <div style={{position: "relative"}} ref={soundContainerRef}>
                <LiveStreamSlidePlayerContainer
                    gameInfo={props.gameInfo}
                    muted={muted}
                    isInCenterStage={true}
                    inViewport={true}
                    display={true}
                    loop={true}
                    videoPlayingService={liveStreamPlaying}
                    onWatchTimeLimitReached={() => {}} //TODO we will have a task for videoPlayer
                    onLoading={() => {}} //TODO we will have a task for videoPlayer
                    onError={() => {}} //TODO we will have a task for videoPlayer
                />
                <VideoSlidesSoundIconComponent containerRef={soundContainerRef}/>
            </div>
            <FlexGrowItemBox/>
        </>
    )
});
